import * as React from "react";
import  AppSetting  from "./AppSetting";
import AppNotificationSetting  from "./AppNotificationSetting";
import AccessibilitySetting  from "./AccessibilitySetting";
import LanguageSetting from "./LanguageSetting";

function Setting() {
  const [settingType, setSettingType] = React.useState('general');

  const handleGeneralAppSetting = (setting: string) => {
    console.log("setting", setting);
    setSettingType(setting);
  };

  const handleNotificationSetting = () => {
    setSettingType('general');
  };

  const handleAccessibilityAppSetting = (setting: string) => {
    setSettingType(setting);
  };


  const handleLanguageAppSetting = (setting: string) => {
    setSettingType(setting);
  };

  const renderSettingContent = () => {
    switch (settingType) {
      case 'general':
        return <AppSetting handleGeneralAppSetting={handleGeneralAppSetting} />;
      case 'notificationSetting':
        return <AppNotificationSetting handleNotificationSetting={handleNotificationSetting} />;
      case 'accessibility':
        return <AccessibilitySetting handleAccessibility={handleAccessibilityAppSetting} />;
      case 'language':
            return <LanguageSetting handleLanguage={handleLanguageAppSetting} />;
        
        default:
        return null;
    }
  };

  return <>{renderSettingContent()}</>;
}

export default Setting;
